var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThemePreviewLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 57,
    viewBox: "0 0 90 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 57,
    rx: 4,
    transform: "translate(718 420)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-40.165a81.032,81.032,0,0,1,18.368-2.866c.243-.009.447.134.447.314s-.175.3-.4.313a102.259,102.259,0,0,0-17.366,2.24c0,.027-1.049.16-1.049,0m16.509-6.491a3.081,3.081,0,0,1,.428-.659c.04.02-.047.308-.274.7a4.809,4.809,0,0,1-.668.884c.047-.113.341-.622.515-.921m-12.315.308a.586.586,0,0,1,.407.079.979.979,0,0,1,.354.495.908.908,0,0,1-.2.673c-.16.222-.354.573-.447.737-.06.108-.134.168-.261.059a.391.391,0,0,1-.16-.318,1.376,1.376,0,0,1,.307-.694l.054-.083.035-.056c.134-.214.242-.424.165-.466-.247-.137-1.711.975-1.744,1.7-.02.417.9.657,1.156.8a.344.344,0,0,1,.2.294.948.948,0,0,1-.261.536,1.414,1.414,0,0,1-.9.437,2.1,2.1,0,0,1-1.664-.613c-.093-.1-.047-.17.047-.214a1.015,1.015,0,0,1,.207-.046.789.789,0,0,1,.521.09,1.835,1.835,0,0,0,1.089.374.6.6,0,0,0,.355-.146.163.163,0,0,0-.007-.263,5.207,5.207,0,0,0-.473-.234l-.08-.037c-.427-.2-.857-.441-.857-.878,0-.854,1.042-1.737,1.644-2.054A1.388,1.388,0,0,1,4.194-46.349Zm12.522-1.509c.127-.136.247-.189.374-.092a.518.518,0,0,1,.22.43.828.828,0,0,1-.04.269,4.453,4.453,0,0,1-1.523,2.057,2.558,2.558,0,0,0-.221.852c0,.151.04.252.127.241.307-.04.695-.511.949-1a.3.3,0,0,1,.084-.1c.14-.216.305-.456.477-.679a.273.273,0,0,1-.127-.216,1.154,1.154,0,0,1,.635-.849c.14-.018.2.049.2.194a1.81,1.81,0,0,1-.12.518,1.944,1.944,0,0,0,.541-.334c.114-.09.18-.111.267-.041a.531.531,0,0,1,.194.377.427.427,0,0,1-.107.259,2.808,2.808,0,0,0-.742,1.353c0,.164.053.257.147.245.227-.029.495-.416.7-.876.053-.12.147-.138.207-.033a.5.5,0,0,1-.02.411,1.286,1.286,0,0,1-.935.75.5.5,0,0,1-.628-.528,2.726,2.726,0,0,1,.688-1.358,1.62,1.62,0,0,1-.488.164,9.036,9.036,0,0,0-.976,1.955c-.027.116-.114.184-.234.08a.41.41,0,0,1-.159-.271,1.308,1.308,0,0,1-.549.224.509.509,0,0,1-.627-.331,1.539,1.539,0,0,1-.9.547c-.454.059-.7-.142-.7-.481a1.054,1.054,0,0,1,.1-.421c.107-.228.328-.6.481-.841.147-.227.307-.436.254-.429s-.194.088-.588.51a6.43,6.43,0,0,0-1.122,1.817c-.067.128-.16.159-.267.072a.362.362,0,0,1-.147-.326,1.606,1.606,0,0,1,.12-.481,6.656,6.656,0,0,1,.494-.893c.181-.306.368-.569.307-.561a2.335,2.335,0,0,0-.715.645,6.313,6.313,0,0,0-.942,1.649c-.047.107-.12.154-.234.074a.359.359,0,0,1-.115-.125,1.257,1.257,0,0,1-.6.281c-.394.051-.6-.105-.622-.384a1.449,1.449,0,0,1-.869.546.367.367,0,0,1-.43-.214,1.463,1.463,0,0,1-.752.386.53.53,0,0,1-.662-.562,3.152,3.152,0,0,1,.722-1.425,1.885,1.885,0,0,1-.521.181C6.847-43.558,6.1-42.606,5.25-42.5c-.615.08-.949-.254-.949-.744a1.73,1.73,0,0,1,.2-.748,2.032,2.032,0,0,1,1.27-1.157.446.446,0,0,1,.234.02.8.8,0,0,1,.394.307c.1.188-.007.428-.134.69a2.3,2.3,0,0,0-.12.273c-.047.138-.073.173-.24.113a.34.34,0,0,1-.234-.334,1.769,1.769,0,0,1,.154-.466c.067-.141.134-.275.1-.3-.087-.052-.515.387-.8.957a1.774,1.774,0,0,0-.2.724c0,.264.114.425.307.412.655-.06,1.37-1.07,1.717-1.887a.238.238,0,0,1-.187-.252,1.2,1.2,0,0,1,.668-.885c.14-.018.194.057.194.195a1.968,1.968,0,0,1-.127.544,2.022,2.022,0,0,0,.581-.345c.1-.082.207-.121.294-.044a.555.555,0,0,1,.187.4.423.423,0,0,1-.114.266A4.092,4.092,0,0,0,7.728-43.6a.906.906,0,0,0-.053.29c0,.157.053.244.154.238.211-.01.554-.4.762-.827a8.2,8.2,0,0,1,.895-1.669.177.177,0,0,1,.287-.037.4.4,0,0,1,.1.276,3.542,3.542,0,0,1-.422.97l-.055.1c-.091.173-.178.343-.245.49-.12.267-.14.5.007.483.174-.023.528-.5.869-1.042.394-.654.568-1.1.808-1.424.094-.132.2-.171.281-.074a.456.456,0,0,1,.1.314,2.116,2.116,0,0,1-.374.9,2.862,2.862,0,0,0-.454,1.026c0,.113.04.171.127.16.162-.021.387-.283.591-.59a13.4,13.4,0,0,1,1.012-1.923c.087-.131.187-.138.254-.033a.513.513,0,0,1,.094.29.839.839,0,0,1-.02.172,2.093,2.093,0,0,1,.876-.616c.214-.028.354.18.354.444a2.018,2.018,0,0,1,.869-.571c.194-.019.3.137.3.344a2.11,2.11,0,0,1-.414.952,1.876,1.876,0,0,0-.361.813c0,.145.067.237.174.223.207-.027.534-.509.782-.924a.251.251,0,0,1,.052-.064A8.166,8.166,0,0,1,16.716-47.858Z",
    transform: "translate(0 48)",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-718 -420)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 43)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5,
    height: 56,
    transform: "translate(816 377)",
    fill: "#19d8ac"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.5,
    height: 56.5,
    transform: "translate(750 377)",
    fill: "#0058ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,0H65a0,0,0,0,1,0,0V55a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3A3,3,0,0,1,3,0Z",
    transform: "translate(752 379)",
    fill: "#f5f4fa"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.5,
    height: 55,
    transform: "translate(816.5 379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(761.56 409.6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.193,
    height: 14.03,
    rx: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4070.119,9387.108H4114.3",
    transform: "translate(-4066.817 -9384.13)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4070.119,9387.108H4089.7",
    transform: "translate(-4066.817 -9380.829)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3,0H48.193a3,3,0,0,1,3,3V7.894a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3A3,3,0,0,1,3,0Z",
    transform: "translate(761.56 426.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(758.303 381.151)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-49H18.352v8.243H-1Z",
    transform: "translate(0.831 48.835)",
    fill: "#0057ff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4070.12,9387.108h4.972",
    transform: "translate(-3307.322 -8990.212)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4073.062,9395.453h46.078",
    transform: "translate(-3309.026 -8991.669)",
    fill: "none",
    stroke: "#edeff2",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4070.12,9387.108h4.972",
    transform: "translate(-3248.698 -8990.212)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.476,0H19.817a0,0,0,0,1,0,0V4.952a0,0,0,0,1,0,0H2.476A2.476,2.476,0,0,1,0,2.476v0A2.476,2.476,0,0,1,2.476,0Z",
    transform: "translate(820.183 401.346)",
    fill: "#edeff2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4070.121,9387.108h15.116",
    transform: "translate(-3261.084 -9001.442)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4070.119,9387.108h29.888",
    transform: "translate(-3305.258 -8958.025)",
    fill: "none",
    stroke: "#111",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemePreviewLight);
export default __webpack_public_path__ + "static/media/theme-preview-light.c001f2e21b19deb685928bd9eb9feccb.svg";
export { ForwardRef as ReactComponent };